export default {
  "hierarchy": {
    "vertical": [
      "propertyGrid-vertical"
    ],
    "twoColumns": [
      "propertyGrid-twoColumns"
    ],
    "operatingHours": [
      "propertyGrid-operatingHours"
    ],
    "operatingHoursTimezone": [
      "propertyGrid-operatingHoursTimezone"
    ],
    "editor": [
      "propertyGrid-editor"
    ],
    "attributeCoordinateEditor": [
      "propertyGrid-editor",
      "propertyGrid-attributeCoordinateEditor"
    ],
    "yAxisEditor": [
      "propertyGrid-yAxisEditor"
    ],
    "xAxisEditor": [
      "propertyGrid-xAxisEditor"
    ],
    "scaleEditor": [
      "propertyGrid-editor",
      "propertyGrid-scaleEditor"
    ],
    "seriesEditor": [
      "propertyGrid-editor",
      "propertyGrid-seriesEditor"
    ],
    "conditionRule": [
      "propertyGrid-conditionRule"
    ],
    "overrideEditor": [
      "propertyGrid-overrideEditor"
    ],
    "tempUserEditor": [
      "propertyGrid-tempUserEditor"
    ],
    "shareTempUser": [
      "propertyGrid-tempUserEditor",
      "propertyGrid-shareTempUser"
    ],
    "attributeEditor": [
      "propertyGrid-attributeEditor"
    ],
    "thumbnail": [
      "propertyGrid-thumbnail"
    ],
    "imagesListEditor": [
      "propertyGrid-imagesListEditor"
    ],
    "runInference": [
      "propertyGrid-editor",
      "propertyGrid-runInference"
    ],
    "rsrcGalleryEditor": [
      "propertyGrid-rsrcGalleryEditor"
    ],
    "rsrcEditor": [
      "propertyGrid-rsrcEditor"
    ]
  },
  "props": {
    "default": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": "default",
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "vertical": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": "noPad",
      "subheaderVariant": "subtitle",
      "vertical": true
    },
    "twoColumns": {
      "columns": 2,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": "noPad",
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "operatingHours": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "operatingHoursTimezone": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": "default",
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "editor": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": true,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "attributeCoordinateEditor": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "yAxisEditor": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "xAxisEditor": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "scaleEditor": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "seriesEditor": {
      "columns": 1,
      "headerVariant": "editorTitle",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "conditionRule": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "overrideEditor": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "tempUserEditor": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": true
    },
    "shareTempUser": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "attributeEditor": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "thumbnail": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": "captionSmall",
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "imagesListEditor": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "runInference": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "rsrcGalleryEditor": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    },
    "rsrcEditor": {
      "columns": 1,
      "headerVariant": "title",
      "inline": false,
      "labelVariant": null,
      "subheaderVariant": "subtitle",
      "vertical": false
    }
  }
}